import { gql } from '@apollo/client';

export * from './agreementGenerate.mutation.generated';

export const AGREEMENT_GENERATE = gql`
  mutation agreementGenerate($escrowId: ID!) {
    agreementGenerate(input: { escrowId: $escrowId }) {
      success
      errors
      escrow {
        id
      }
    }
  }
`;
